import { render, staticRenderFns } from "./NgJsonPretty.vue?vue&type=template&id=38df474a"
import script from "./NgJsonPretty.vue?vue&type=script&lang=js"
export * from "./NgJsonPretty.vue?vue&type=script&lang=js"
import style0 from "./NgJsonPretty.vue?vue&type=style&index=0&id=38df474a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports